export const INVOICE_SECTIONS = [
  ['invoices', 'Загрузить инвойсы'],
  ['saved', 'Сохранённые инвойсы'],
  ['check', 'Проверка инвойсов'],
  ['export', 'Выгрузка'],
];
